import { Slide } from "@jelly/lesson";
import { task as task01 } from "../../../../../task/course-05/lesson-05/task-01";

const task: Slide = {
  titleHtml:
    "Connect the sounds of the impulse responses of some rooms on the left side with the<br>matching room figures on the right side. Use the estimated reverberation time as a guide.",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
